<div class="table-responsive" [class.overflow-hidden]="es.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover email-list-table footable">
        <thead>
            <tr>
                <th (click)="orderBy('subject', $event)">Subject
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('pmName', $event)" *ngIf="!authenticationService.userIsResident">Created By
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc">Created On
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('status', $event)" *ngIf="!authenticationService.userIsResident">Status
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('recipientsCount', $event)" *ngIf="!authenticationService.userIsResident">Recipient
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('sentCount', $event)" *ngIf="!authenticationService.userIsResident">Sent
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('openedCount', $event)" *ngIf="!authenticationService.userIsResident">Opened
                    <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('clickedCount', $event)" *ngIf="!authenticationService.userIsResident">Clicked
                    <span class="footable-sort-indicator"></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of es.data.entities; let index = index;" [ngClass]="{'footable-odd': (index % 2 === 0)}">
                <td>
                    <div class="table-mobile-left">
                        <span>Subject</span>
                    </div>
                    <span class="clickable-text mtv-primary-color"
                          [ngStyle]="{'font-weight': authenticationService.userIsResident && !item.readAt ? 'bold' : ''}"
                          (click)="showEmailViewModal(item, index)">
                        {{item.subject}}
                    </span>
                </td>
                <td *ngIf="!authenticationService.userIsResident">
                    <div class="table-mobile-left">
                        <span>Created By</span>
                    </div>
                    <span>{{item.pmName}}</span>
                </td>
                <td>
                    <div class="table-mobile-left">
                        <span>Created On</span>
                    </div>
                    <span>{{item.createdAt | mccDate:true:true}}</span>
                </td>
                <td *ngIf="!authenticationService.userIsResident">
                    <div class="table-mobile-left">
                        <span>Status</span>
                    </div>
                    <div class="table-mobile-right">
                        <span *ngIf="item.status === 'in_progress'" class="text-uppercase label label-in-progress">in progress</span>
                        <span *ngIf="item.status === 'completed'" class="text-uppercase label label-completed">completed</span>
                        <span *ngIf="item.status === 'draft'" class="text-uppercase label label-draft">draft</span>
                        <span *ngIf="item.status === 'scheduled'" class="text-uppercase label label-scheduled">scheduled</span>
                    </div>
                </td>
                <td *ngIf="!authenticationService.userIsResident">
                    <div class="table-mobile-left">
                        <span>Recipient</span>
                    </div>
                    <span class="clickable-text mtv-primary-color" (click)="es.showMailingResultModal(item)">
                        {{item.recipientsCount}}
                    </span>
                    <span style="padding: 0;" class="mtv-primary-color" *ngIf="item.errorCount > 0" title="{{item.errorCount}}">
                        (!)
                    </span>
                </td>
                <td *ngIf="!authenticationService.userIsResident">
                    <div class="table-mobile-left">
                        <span>Sent</span>
                    </div>
                    <span>{{item.sentCount}}</span>
                </td>
                <td *ngIf="!authenticationService.userIsResident">
                    <div class="table-mobile-left">
                        <span>Opened</span>
                    </div>
                    <span>{{dateIsLaterThanParticularOtherDate(item.createdAt) ? item.openedCount : 'N/A'}}</span>
                </td>
                <td *ngIf="!authenticationService.userIsResident">
                    <div class="table-mobile-left">
                        <span>Clicked</span>
                    </div>
                    <span>{{dateIsLaterThanParticularOtherDate(item.createdAt) ? item.clickedCount : 'N/A'}}</span>
                </td>
            </tr>
            <tr *ngFor="let item of es.emptyRowService.emptyRow" class="empty-row">
                <td>&nbsp;</td>
                <td *ngIf="!authenticationService.userIsResident"></td>
                <td></td>
                <td *ngIf="!authenticationService.userIsResident"></td>
                <td *ngIf="!authenticationService.userIsResident"></td>
                <td *ngIf="!authenticationService.userIsResident"></td>
                <td *ngIf="!authenticationService.userIsResident"></td>
                <td *ngIf="!authenticationService.userIsResident"></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!es.data.total"
                          [isServiceUnavailable]="es.showServiceUnavailable"
                          [isLoading]="es.spinnerShow">
        You email box is empty<br>
        <span *ngIf="es.account.canUpdate(es.serviceName)">
            <a [routerLink]="['/email-merge/compose']" class="mtv-primary-color clickable-text">compose email</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/email/email-list/email-list.component.html